export default {
  getCardSet(state) {
    return state.cardSet;
  },
  getCardSetDetails(state) {
    return state.cardSetDetails;
  },
};
